export default __webpack_public_path__ + "static/media/bx_bx-map.468c7eb2.svg";